// test1955
(1955 && 0);
